import React from "react";
import { Cpu, Wrench, ShieldCheck, Zap } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const statsData = [{
  label: "Local & Trusted",
  description: "PROUDLY SERVING PFLUGERVILLE, TX",
  icon: Wrench
}, {
  label: "Precise Diagnostics",
  description: "EVERY ISSUE IDENTIFIED & EXPLAINED",
  icon: Cpu
}, {
  label: "Flexible Scheduling",
  description: "BOOK AROUND YOUR SCHEDULE",
  icon: ShieldCheck
}, {
  label: "Fast Turnaround",
  description: "24–48 HOURS TYPICAL",
  icon: Zap
}];
export default function TrustBarStats() {
  return <section id="trustbarstats" className="bg-background relative overflow-hidden py-12 border-y border-border/40">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-[0.03] pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
          {statsData.map((stat, i) => {
          const Icon = stat.icon;
          return <Card key={i} data-index={i} className="group relative overflow-hidden bg-card/40 backdrop-blur-sm border-border/50 hover:border-primary/50 transition-colors duration-300 rounded-lg shadow-sm hover:shadow-md hover:shadow-primary/10">
                <div className="absolute top-0 left-0 h-full w-1/2 bg-gradient-to-r from-transparent via-primary/20 to-transparent -translate-x-[150%] skew-x-[-45deg] transition-transform duration-700 ease-out group-hover:translate-x-[250%] pointer-events-none z-0" />

                <CardContent className="p-4 sm:p-6 flex flex-col items-center text-center relative z-10">
                  <div className="mb-4 p-3 rounded-md bg-background/50 border border-border/50 group-hover:border-primary/30 transition-colors duration-300">
                    <Icon className="size-6 md:size-7 lg:size-8 text-primary transition-all duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:skew-x-6 group-hover:scale-110" />
                  </div>
                  
                  <h3 className="font-default text-xl md:text-2xl lg:text-3xl font-bold text-foreground tracking-tight mb-1 group-hover:text-primary transition-colors duration-300">
                    {stat.label}
                  </h3>
                  
                  <p className="font-sans text-xs sm:text-sm md:text-base text-muted-foreground uppercase tracking-wider font-medium">
                    {stat.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}